import React, { useMemo, useState } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import CurFt from "./CurFt";
import { toast } from 'react-hot-toast';
import WhatsAppShare from "./WhatsAppShare";
import { ShareFlightProposal } from "../features/flight/flightSlice";
const FlightProposalShare = ({
    selectedFlights = [],
    setSelectedFlights = [],
    handleShareSelection = [],
    FormData,
    setshowProposalPopup,
    onSetShare,
    user,
}) => {

    const dispatch = useDispatch();
    const handleExtraMarkup = (index, field, value) => {
        setSelectedFlights((prevFlights) =>
            prevFlights.map((flight, i) => {
                if (i !== index) return flight;

                const extraMarkup = parseFloat(value) || 0;

                const originalPublishedFare =
                    flight.OriginalPublishedFare ??
                    flight.FareList?.[0]?.PublishedFare ??
                    0;

                return {
                    ...flight,

                    [field]: value,

                    OriginalPublishedFare: originalPublishedFare,

                    FareList: flight.FareList.map((fare, fareIndex) =>
                        fareIndex === 0
                            ? {
                                ...fare,
                                PublishedFare: originalPublishedFare + extraMarkup,
                            }
                            : fare
                    ),
                };
            })
        );
    };
    const [emailInput, setEmailInput] = useState('');
    const [contactInfo, setContactInfo] = useState({
        email: '',
        FromSec: FormData.from,
        ToSec: FormData.to,
        departureDate: FormData.departureDate,
        returnDate: FormData.returnDate,
        routeType: FormData.routeType,
        selectedClass: FormData.selectedClass,
        adults: FormData.adults,
        children: FormData.children,
        infants: FormData.infants,
    });
    const addEmail = (email) => {
        email = email.trim();

        if (!email) return;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            toast.error('Enter Valid Email id!', { autoClose: 3000 });
            return;
        }

        const existingEmails = contactInfo.email
            ? contactInfo.email.split(',').map(e => e.trim()).filter(Boolean)
            : [];

        // Prevent duplicate email
        if (existingEmails.includes(email)) {
            setEmailInput('');
            return;
        }

        const updatedEmails = [...existingEmails, email];

        setContactInfo(prev => ({
            ...prev,
            email: updatedEmails.join(','),
        }));

        setEmailInput('');
    };

    const removeEmail = (emailToRemove) => {
        const emails = contactInfo.email
            .split(',')
            .map(e => e.trim())
            .filter(e => e && e !== emailToRemove);

        setContactInfo(prev => ({
            ...prev,
            email: emails.join(','),
        }));
    };

    const handleEmailKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();

            addEmail(emailInput);
        }
    };
    const [Loading, setLoading] = useState(false);
    const handleSubmitSelectedFlights = async () => {
        // 
        setLoading(true)
        const existingEmails = contactInfo.email
            ? contactInfo.email.split(',').map(e => e.trim()).filter(Boolean)
            : [];


        const payload = {
            selectedFlights,
            ...contactInfo,
        };
        if (existingEmails.length === 0) {
            toast.error('Enter at least 1 Email id!', { autoClose: 3000 });
            return
        }

        try {
            const response = await dispatch(
                ShareFlightProposal({ payload })
            ).unwrap();
            if (response.data.status.success) {
                setLoading(false)
                setshowProposalPopup(false)
                onSetShare(false)
                setSelectedFlights([])
                toast.success(response.data.message, { autoClose: 2000 });
            } else {
                toast.error(response.data.message, { autoClose: 2000 });
            }
            // console.log("API Response:", response);
        } catch (error) {
            console.error("Error:", error);
        }
    };
    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-2xl w-full mx-4 max-h-96 overflow-y-auto">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-semibold">Selected Flights ({selectedFlights.length})</h3>
                        <button
                            onClick={() => { setshowProposalPopup(false); onSetShare(false) }}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                    </div>

                    <div className="space-y-4 mb-6">
                        {selectedFlights.map((selectedFlight, index) => (
                            <div key={selectedFlight.keyIndex} className="border rounded-lg p-4">
                                {/* Flight Header */}
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                                            <img
                                                src={`/AirlineLogo/${selectedFlight.AirlineCode}.png`}
                                                alt={selectedFlight.AirlineName}
                                                className="object-contain rounded-md w-full h-full"
                                            />
                                        </div>
                                        <div>
                                            <p className="font-medium">{selectedFlight.AirlineName}</p>
                                            <p className="text-xs text-gray-600">{selectedFlight.FlightNumber}</p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => handleShareSelection(selectedFlight, selectedFlight?.FareList?.[0]?.PriceID, false)}
                                        className="text-red-500 hover:text-red-700 text-sm"
                                    >
                                        Remove
                                    </button>
                                </div>

                                {/* Flight Details */}
                                <div className="grid grid-cols-3 gap-4 text-sm">
                                    <div className="text-center">
                                        <p className="text-lg font-bold">{format(new Date(selectedFlight.FromUTCTime), "HH:mm")}</p>
                                        <p className="text-gray-600">{selectedFlight.SoCity}</p>
                                    </div>
                                    <div className="text-center">
                                        <p className="font-medium">{selectedFlight.Duration}</p>
                                        <p className="text-gray-600">{selectedFlight.StopCount}</p>
                                    </div>
                                    <div className="text-center">
                                        <p className="text-lg font-bold">{format(new Date(selectedFlight.ToUTCTime), "HH:mm")}</p>
                                        <p className="text-gray-600">{selectedFlight.DeCity}</p>
                                    </div>
                                </div>

                                {/* Fare Details */}
                                {selectedFlight.FareList && selectedFlight.FareList[0] && (
                                    <div className="mt-3 pt-3 border-t">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">
                                                {selectedFlight.FareList[0].Checkin}/{selectedFlight.FareList[0].Cabin}
                                            </span>
                                            <span className="font-medium">
                                                <input
                                                    value={selectedFlight?.ExtraMarkup || null}
                                                    onChange={(e) => { handleExtraMarkup(index, 'ExtraMarkup', e.target.value) }}
                                                    type="text"
                                                    id="ExtraMarkup"
                                                    className="w-full px-3 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    placeholder="Add Markup"
                                                    required
                                                />
                                            </span>
                                            <span className="font-medium">
                                                <CurFt
                                                    currency={selectedFlight.FareList[0]?.symbol || "INR"}
                                                    price={selectedFlight.FareList[0].PublishedFare}
                                                />
                                            </span>

                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Contact Information Form */}
                    <div className="border-t pt-4">
                        {/* <h4 className="font-semibold mb-4">Contact Information</h4> */}
                        <div className="space-y-4">
                            {/* <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                                  Full Name *
                                </label>
                                <input
                                  type="text"
                                  id="name"
                                  value={contactInfo.name}
                                  onChange={handleInputChange}
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                  placeholder="Enter your full name"
                                  required
                                />
                              </div>
            
                              <div>
                                <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-1">
                                  Mobile Number *
                                </label>
                                <input
                                  value={contactInfo.mobile}
                                  onChange={handleInputChange}
                                  type="tel"
                                  id="mobile"
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                  placeholder="Enter your mobile number"
                                  required
                                />
                              </div> */}

                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700 mb-1"
                                >
                                    Email Address *
                                </label>

                                <div className="w-full min-h-[42px] px-2 py-1 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent flex flex-wrap items-center gap-1">

                                    {/* Email Tags */}
                                    {contactInfo.email
                                        .split(',')
                                        .map(e => e.trim())
                                        .filter(Boolean)
                                        .map((email) => (
                                            <div
                                                key={email}
                                                className="flex items-center gap-2 bg-gray-200 text-gray-800 px-2 py-1 rounded-sm text-sm"
                                            >
                                                <span>{email}</span>

                                                <button
                                                    type="button"
                                                    onClick={() => removeEmail(email)}
                                                    className="text-gray-500 hover:text-gray-800 font-bold text-lg leading-none"
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}

                                    {/* Email Input */}
                                    <input
                                        type="text"
                                        id="email"
                                        value={emailInput}
                                        onChange={(e) => setEmailInput(e.target.value)}
                                        onKeyDown={handleEmailKeyDown}
                                        onBlur={() => {
                                            if (emailInput.trim()) {
                                                addEmail(emailInput);
                                            }
                                        }}
                                        className="flex-1 min-w-[180px] border-0 outline-none focus:ring-0 px-1 py-1 text-sm"
                                        placeholder={
                                            contactInfo.email
                                                ? ""
                                                : "Enter email address"
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-end gap-3 mt-6">
                        <button
                            onClick={() => setSelectedFlights([])}
                            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        {/* <a href="https://api.whatsapp.com/send?text=Hello" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-x-2 rounded-lg bg-[#25D366] px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#20ba5a] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366] transition-colors duration-200">
            
                              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24" xmlns="http://w3.org">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.746.953 3.71 1.454 5.709 1.455h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                              </svg>
                              <span>Chat on WhatsApp</span>
                            </a> */}
                        <WhatsAppShare
                            selectedFlights={selectedFlights}
                            fromCity={FormData?.from}
                            toCity={FormData?.to}
                            adults={FormData?.adults}
                            children={FormData?.children}
                            infants={FormData?.infants}
                            adults={FormData?.adults}
                            cabinClass={FormData?.selectedClass}
                            contact={user?.UserData.mobile}
                            email={user?.UserData.email}
                            company={user?.UserData.user.details.agencyName}
                        />
                        <button
                            disabled={Loading}
                            onClick={handleSubmitSelectedFlights}
                            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                        >
                            {Loading ? 'Please wait...' : 'Send Email'}
                        </button>
                    </div>
                </div>
            </div>
        </>

    );
};

export default FlightProposalShare;